import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import { noMultipleClicks, setCodeTimer, getCodeTimer } from './utils/common.js'//防止事件点击与预览

// 引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
Vue.use(VueCookies)

import * as filters from './filters' // global filters

// 引入QRcode
import QRCode from 'qrcode'
Vue.use(QRCode)

//引入less
import less from 'less'
Vue.use(less)

// 引入下拉加载
import elTableInfiniteScroll from "el-table-infinite-scroll";
Vue.use(elTableInfiniteScroll);

import apiFun from "@/api/login.js";
Vue.prototype.$apiFun = apiFun;//请求接口api
Vue.prototype.$noMultipleClicks = noMultipleClicks;
Vue.prototype.$setCodeTimer = setCodeTimer;
Vue.prototype.$getCodeTimer = getCodeTimer;

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})



// 测试服、正式服OSS域名
Vue.prototype.IMG_URL = ""


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
